import * as yup from 'yup';

export const vehicleValidations = yup.object().shape({
  plate: yup.string().required('A placa é obrigatório'),
});

export const cardValidations = yup.object().shape({
  cardCode: yup.number().required('O número do cartão é obrigatório'),
});
